<template>
  <el-form :model="model" label-width="120px" ref="form" :rules="rules">
    <el-form-item>
      <el-alert
        title="Reset password error!"
        type="error"
        v-if="error"
        :closable="false"
      />
      <el-alert
        :title="sendCodeMessage"
        type="error"
        v-if="sendCodeError"
        :closable="false"
      />
    </el-form-item>
    <el-form-item
      :label="$t('login.REGISTER.mobile')"
      prop="mobile"
      style="margin-bottom: 30px"
    >
      <el-input
        v-model="model.mobile"
        size="large"
        :placeholder="$t('login.REGISTER.inputmobile')"
        prefix-icon="User"
      />
    </el-form-item>
    <el-form-item
      :label="$t('login.REGISTER.newpassword')"
      prop="password"
      style="margin-bottom: 30px"
    >
      <el-input
        type="password"
        v-model="model.password"
        size="large"
        placeholder="Please input new password"
        prefix-icon="Lock"
      />
    </el-form-item>
    <el-form-item
      :label="$t('login.REGISTER.code')"
      prop="code"
      style="margin-bottom: 30px"
    >
      <el-row :gutter="10">
        <el-col :span="20">
          <el-input
            v-model="model.code"
            size="large"
            :placeholder="$t('login.REGISTER.inputsmscode')"
            prefix-icon="Lock"
          />
        </el-col>
        <el-col :span="4">
          <el-button
            size="large"
            :disabled="totalCountdownTime < 60"
            @click="sendSMSCode"
          >
            {{ btnSMScontent }}
          </el-button>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        size="large"
        style="width: 100%"
        :loading="loading"
        @click="resetPassword"
        >Confirm</el-button
      >
    </el-form-item>
    <div style="text-align: right">
      <el-button link @click="() => this.$emit('return_to_login')">
        {{ $t('login.REGISTER.returntologin') }}
      </el-button>
    </div>
  </el-form>
</template>
<script>
import axios from 'axios';
import SmsMixin from './SmsMixin';
import {
  validateMobile,
  validatePassword,
} from './validator';
export default {
  mixins: [SmsMixin],
  data() {
    return {
      rules: {
        mobile: [
          { required: true, validator: validateMobile, trigger: 'blur' },
        ],
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' },
        ],
        code: [
          {
            required: true,
            message: this.$t('login.REGISTER.inputcode'),
            trigger: 'blur',
          },
        ],
      },
      model: {
        mobile: null,
        password: null,
        code: null,
      },
      smsCode: null,
      loading: false,
      error: false,
      sendSmsUrl: '/v1.0/user/mobile/reset_password/code',
    };
  },
  methods: {
    async resetPassword() {
      let isValid = false;
      await this.$refs.form.validate(
        (valid) => (isValid = valid),
      );
      if (!isValid) return;
      this.loading = true;
      this.error = false;

      const baseURL = process.env.VUE_APP_MAPSCLOUD_AUTH_SERVER;
      const url = '/v1.0/user/mobile/reset_password';
      const reqConf = {
        method: 'POST',
        baseURL,
        url,
        data: this.model,
      };
      try {
        const { data } = await axios(reqConf);
        this.loading = false;
        if (data.status == 0) {
          this.$notify.success({
            title: this.$t('login.LOGIN.forget'),
            message: 'Reset password success!',
          });
          this.$emit('return_to_login');
        } else {
          this.error = data.message;
        }
      } catch (err) {
        this.error = true;
        this.loading = false;
        console.log(err);
      }
    },
  },
};
</script>
